import * as React from 'react'

import { Box, InputCheckBox, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { CHANNEL_WIDTH } from 'modules/notifications/components/Preferences/PreferencesList/_Category/constants'
import type { NotifierChannelData } from 'modules/notifications/components/Preferences/PreferencesList/hooks/useComputedPreferences'
import type UserPreference from 'modules/notifications/store/models/UserPreference'

export interface Props {
  channelData?: NotifierChannelData
  preference?: UserPreference
  onPreferenceUpdated: (preference: UserPreference, newValue: boolean) => Promise<void>
}

export const PreferenceCheck = observer(
  ({ channelData, preference, onPreferenceUpdated }: Props) => {
    const { performAction } = useAsyncAction(async () => {
      if (preference) {
        const newValue = !preference.isEnabled

        await onPreferenceUpdated(preference, newValue)

        track(trackingEvents.inbox.preferences.updateNotifier, {
          changed_to: newValue,
          notifier: preference.notifier,
          channel: preference.channel,
        })
      }
    })
    const [tooltipOpen, toggleTooltip] = useToggle()

    const isPresent = channelData && preference

    return (
      <Box width={CHANNEL_WIDTH} flexNoShrink alignItems="center">
        {isPresent ? (
          <InputCheckBox
            disabled={!channelData.editable}
            checked={preference.isEnabled}
            onClick={performAction}
          />
        ) : (
          <Tooltip.Alt
            open={tooltipOpen}
            toggle={toggleTooltip}
            attachment="bottom center"
            label={i18n.t('notifications.preferences.channel_not_configurable')}
          >
            <InputCheckBox disabled checked={false} />
          </Tooltip.Alt>
        )}
      </Box>
    )
  }
)
